import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from '../../Images/logo.png'
import { FaUsers } from "react-icons/fa";

// ─── Icons (inline SVG helpers) ───────────────────────────────────────────────
const Icon = ({ d, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);
const ChevronRight  = () => <Icon d="M9 18l6-6-6-6" />;
const ChevronDown   = () => <Icon d="M6 9l6 6 6-6" />;
const DashboardIcon = () => (
  <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
  </svg>
);
const UserIcon      = () => <Icon d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />;
const PagesIcon     = () => <Icon d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />;
// const FormIcon      = () => <Icon d="M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />;

// ─── Nav data ─────────────────────────────────────────────────────────────────
const navItems = [
  { label: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
  { icon: <UserIcon />, label: "Admin", path: "/dashboard/admin" },

  {
    label: "Pages",
    icon: <PagesIcon />,
    defaultOpen: true,
    children: [
      {
        label: "About",
        defaultOpen: false,
        children: [
          { label: "Our Company", path: "/dashboard/company" },
          { label: "Leadership", path: "/dashboard/leadership" },
          { label: "QHSE", path: "/dashboard/safety-policy" },
        ],
      },
      {
        label: "Services",
        defaultOpen: false,
        children: [
          { label: "Engineering", path: "/dashboard/engineering" },
          { label: "Commissioning", path: "/dashboard/commissioning" },
          { label: "Procurement", path: "/dashboard/procurement" },
          { label: "Construction", path: "/dashboard/construction" },
          { label: "Manpower-supply", path: "/dashboard/manpower-supply" },
          { label: "installation-instrumentation", path: "/dashboard/installation-instrumentation" },
          { label: "Marine-support", path: "/dashboard/marine-support" },
        ],
      },
      { label: "Careers", path: "/dashboard/careers" },
      { label: "Contact", path: "/dashboard/contact" },
      { label: "Application", path: "/dashboard/application" },
    ],
  },

  {
    label: "Components",
    icon: <FaUsers />,
    defaultOpen: true,
    children: [
      { label: "Footer", path: "/dashboard/footer" },
      { label: "NavBar", path: "/dashboard/navbar" },
      { label: "Partnership", path: "/dashboard/partnership"},
      { label: "Testimoy", path: "/dashboard/testimoy" }, 
      { label: "Projects", path: "/dashboard/projects" },
    ],
  },

  // { label: "Application Form", icon: <FormIcon />, path: "/dashboard/application-form" },
];

// ─── NavItem ──────────────────────────────────────────────────────────────────
function NavItem({ item, depth = 0 }) {
  const location = useLocation();
  const hasChildren = item.children && item.children.length > 0;

  // Auto-open if current route matches any child path
  const isChildActive = (node) => {
    if (node.path && location.pathname === node.path) return true;
    if (node.children) return node.children.some(isChildActive);
    return false;
  };

  // Open by default if: item has defaultOpen flag, OR a child route is active
  const [open, setOpen] = useState(() => item.defaultOpen === true || isChildActive(item));

  const isActive = item.path && location.pathname === item.path;
  const paddingLeft = 20 + depth * 14;

  const rowClass = [
    "admin_nav__row",
    isActive ? "admin_nav__row--active" : "",
  ].filter(Boolean).join(" ");

  const rowContent = (
    <>
      <div className="admin_nav__left">
        {item.icon && (
          <span className={`admin_nav__icon${isActive ? " admin_nav__icon--active" : ""}`}>
            {item.icon}
          </span>
        )}
        <span>{item.label}</span>
      </div>
      <span className="admin_nav__chevron">
        {hasChildren
          ? open ? <ChevronDown /> : <ChevronRight />
          : <ChevronRight />}
      </span>
    </>
  );

  return (
    <div>
      {hasChildren ? (
        <div
          className={rowClass}
          style={{ padding: `9px 16px 9px ${paddingLeft}px` }}
          onClick={() => setOpen(!open)}
        >
          {rowContent}
        </div>
      ) : (
        <Link
          to={item.path || "#"}
          className={rowClass}
          style={{ padding: `9px 16px 9px ${paddingLeft}px`, textDecoration: "none" }}
        >
          {rowContent}
        </Link>
      )}

      {hasChildren && open && (
        <div>
          {item.children.map((child, i) => (
            <NavItem key={i} item={child} depth={depth + 1} />
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Sidebar ──────────────────────────────────────────────────────────────────
export function Sidebar({ collapsed }) {
  return (
    <div className={`admin_sidebar${collapsed ? " admin_sidebar--collapsed" : ""}`}>
      {/* Logo */}
      <div className="admin_sidebar__logo">
        <div>
          <div className="admin_sidebar__logo-name"><img src={Logo} alt="" /></div>
        </div>
      </div>

      {/* Nav */}
      <nav className="admin_sidebar__nav">
        {navItems.map((item, i) => (
          <NavItem key={i} item={item} />
        ))}
      </nav>
    </div>
  );
}